<template>
  <div v-if="displayableLeaders.length">
    <p class="text-caption blue-grey--text mb-1">
      {{ $t('teams.leader', { count: this.leaders.length }) }}
    </p>

    <div class="d-flex">
      <v-tooltip v-for="leader in displayableLeaders" bottom :key="leader._id">
        <template v-slot:activator="{ on, attrs }">
          <UserAvatar
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            size="32px"
            fontSize="10px"
            :account="leader"
          />
        </template>

        {{ getFullName(leader) }}
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import userMixin from '@/mixins/userMixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'
import _ from 'lodash'

const MAX_LEADERS_TO_DISPLAY = 3

export default {
  components: {
    UserAvatar,
  },

  mixins: [userMixin],

  props: {
    leaders: {
      type: Array,
      required: true,
    },
  },

  computed: {
    displayableLeaders() {
      const leaders = _.compact(this.leaders)
      return leaders.slice(0, MAX_LEADERS_TO_DISPLAY)
    },
  },
}
</script>
